import { useState } from 'react';

import Icon from '@components/icon/Icon';
import { MonthArray } from '@constants/groups';
import { PickerProps } from '@types';

const MonthPicker = ({ handleDateRangeSelect, minDate }: PickerProps) => {
  const currentDate = new Date();
  const [selectedYear, setSelectedYear] = useState<number>(
    currentDate.getFullYear()
  );

  const [selectedDate, setSelectedDate] = useState<{
    year: number;
    month: {
      id: number;
      value: string;
      label: string;
    };
  }>();

  const checkForFutureMonth = (item: any) => {
    if (
      item.id > currentDate.getMonth() &&
      selectedYear === currentDate.getFullYear()
    )
      return true;
    return false;
  };

  const checkForPastMonth = (item: any) => {
    if (selectedYear === minDate?.getFullYear())
      if (item.id < minDate.getMonth()) return true;
    return false;
  };

  const handleMonthClick = (item: any) => {
    if (!checkForFutureMonth(item) && !checkForPastMonth(item)) {
      const startOfMonth = new Date(selectedYear, item.id, 1);
      const endOfMonth = new Date(selectedYear, item.id + 1, 0);
      handleDateRangeSelect({
        startDate: startOfMonth,
        endDate: endOfMonth
      });
      setSelectedDate({ year: selectedYear, month: item });
    }
  };

  const handleReduceYear = () => {
    if (minDate) {
      if (selectedYear > minDate.getFullYear()) {
        setSelectedYear((prev) => prev - 1);
      }
    } else setSelectedYear((prev) => prev - 1);
  };

  const handleAddYear = () => {
    if (selectedYear < currentDate.getFullYear()) {
      setSelectedYear((prev) => prev + 1);
    }
  };

  return (
    <>
      <div className="text-sm font-normal text-cofeeNeutral10">Year</div>
      <div className="my-4 flex w-full items-center justify-between rounded-lg border border-cofeeGreyBlue200 bg-cofeeNeutral1 p-6 text-sm text-cofeeNeutral10">
        <Icon
          name="left"
          role="presentation"
          className="cursor-pointer"
          onClick={handleReduceYear}
        />
        <div>{selectedYear}</div>
        <Icon
          name="right"
          role="presentation"
          className="cursor-pointer"
          onClick={handleAddYear}
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        {MonthArray.map((item) => (
          <div
            key={item.id}
            className={`flex h-10 w-full items-center justify-center rounded-lg
            ${
              checkForFutureMonth(item) || checkForPastMonth(item)
                ? 'cursor-not-allowed bg-cofeeNeutral3 text-cofeeNeutral7'
                : 'cursor-pointer border  border-cofeeGreyBlue200 bg-cofeeNeutral1 text-cofeeNeutral10'
            } ${
              selectedDate?.month.id === item.id &&
              selectedDate?.year === selectedYear
                ? 'border !border-cofeePrimary4 !text-cofeePrimary6'
                : ''
            }`}
            role="presentation"
            onClick={() => handleMonthClick(item)}
          >
            {item.label}
          </div>
        ))}
      </div>
    </>
  );
};

export default MonthPicker;
